document.addEventListener('DOMContentLoaded', function() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;
  
  bar.addEventListener('click', function(e) {
    if (e.target === bar || e.target.matches('.announcement-bar::after')) {
      bar.style.display = 'none';
    }
  });
});